<po-modal p-size="xl">
  <div class="po-p-0 po-m-0" style="position: relative">
    <app-dependency-track-vulnerabilities-metrics [items]="vulnerabilities" />

    <po-tabs>
      <po-tab p-active p-label="Vulnerabilidades">
        <app-dependency-track-vulnerabilities-table
          [items]="vulnerabilitiesDetails"
      /></po-tab>

      <po-tab p-label="Métricas">
        <app-dependency-track-vulnerabilities-charts
          [items]="vulnerabilitiesMetrics"
        />
      </po-tab>

      <po-tab p-label="Componentes">
        <app-dependency-track-components
          [projectId]="project?.id"
        />
      </po-tab>
    </po-tabs>

    <po-loading-overlay *ngIf="loading" />
  </div>

  <po-modal-footer>
    <po-button
      p-label="Gerar CSV"
      p-icon="po-icon-print"
      (p-click)="generateCSV()"
      [p-disabled]="
        downloadingCsv ||
        loading ||
        !vulnerabilitiesDetails?.details?.findings?.length
      "
    />

    <po-button p-label="Fechar" p-kind="primary" (p-click)="close()" />
  </po-modal-footer>
</po-modal>
